// LLM generated - Model Claude 4 Sonnet
import { RYPlogoLogin } from '~/domains/design-system/vectors/RYPlogoLogin';
import { OFPlogoLogin } from '~/domains/design-system/vectors/OFPlogoLogin';
import { Text } from '~/domains/design-system/Text';

type BrandLogosProps = {
  className?: string;
  height?: number;
  color?: string;
};

export function BrandLogos({ className, height = 16, color = '#495057' }: BrandLogosProps) {
  return (
    <div className={className}>
      <RYPlogoLogin height={height} color={color} />
      <Text variant="subhead-medium" color="gray2.4">
        or
      </Text>
      <OFPlogoLogin height={height} color={color} />
    </div>
  );
}
